import './styles.scss'
import React from 'react'
import { I18n } from 'react-redux-i18n'

import { deleteLabel, addProcessLabel, deleteProcessLabel } from 'redux/smartchat/header/actions'
import { saveActionDetail, addContainer, copyContainer, confirmCopyContainer, deleteContainer } from 'redux/smartchat/details/actions'
import { Button, ButtonTag } from 'components/Form'
import { Selector, Text } from 'components/SmartChatView/Fields'
import ModalWrapper from 'components/ModalWrapper'
import ModalDelete from 'components/ModalDelete'
import ProcessContainer from './ProcessContainer'
import ActionModal from './ActionModal'
import LabelModal from './LabelModal'
import TagsManager from 'components/TagsManager'
import { getHexLuminance } from 'utils'

const ProcessContentUI = ({
  processName,
  labelsList,
  labelModal,
  processLabels,
  processDetail,
  containerName,
  setContainerName,
  selectedContainerData,
  isOpenActionModal,
  toggleActionModal,
  isOpenDeleteActionModal,
  toggleDeleteActionModal,
  isOpenAddContainerModal,
  toggleAddContainerModal,
  isOpenCopyContainerModal,
  toggleCopyContainerModal,
  isOpenConfirmCopyContainerModal,
  toggleConfirmCopyContainerModal,
  copyContainerOptions,
  copyContainerValue,
  setCopyContainerValue,
  isAdvanceModeEnabled,
  isOpenDeleteContainerModal,
  toggleDeleteContainerModal,
  toggleLabelModal,
  toggleDeleteLabelModal,
  smartChatCollapse,
  onChangeSmartChatCollapse,
  handleAllCollapse,
  modalHeaderLoading,
  modalHeaderError,
  modalLoading,
  modalError,
  dispatch
}) => (
  <div className='process-content animated fadeIn'>
    <div className='process-content__header'>
      <div className='process-content__header-top'>
        <div className='process-content__title-container'>
          <h2>{processName}</h2>
          <TagsManager
            tags={labelsList}
            selectedTags={processLabels}
            buttonToggleTitle={I18n.t('dashboard_labels')}
            buttonEventTitle={I18n.t('dashboard_add-label')}
            handleSelectTag={tag => dispatch(addProcessLabel({ processId: processDetail._id, labelId: tag._id }))}
            handleAddTag={() => toggleLabelModal({ mode: 'add' })}
            handleUpdateTag={tag => toggleLabelModal({ mode: 'update', labelId: tag._id })}
            handleDeleteTag={tag => toggleDeleteLabelModal({ labelId: tag._id })}
          />
        </div>
        <div className='process-content__buttons-collapse'>
          <ButtonTag className='qr-reset-filters' value={I18n.t('dashboard_expand-all')} onClick={() => handleAllCollapse('expand')}/>
          <ButtonTag className='qr-reset-filters' value={I18n.t('dashboard_collapse-all')} onClick={() => handleAllCollapse('collapse')}/>
        </div>
      </div>
      {/* Etiquetas */}
      {processLabels.length > 0 && (
        <div className='process-content__labels'>
          {
            processLabels.map((labelId, index) => {
              const label = labelsList.find(label => label._id === labelId)
              const luminance = getHexLuminance(label.color)

              if (label) {
                return (
                  <div
                    key={index}
                    className='process-content__label'
                    style={{ backgroundColor: label.color || '#ffffff' }}
                  >
                    <span
                      className='text-ellipsis'
                      style={{ color: luminance > 0.4 ? '#333333' : '#ffffff' }}
                    >
                      {label.name}
                    </span>
                    <button onClick={() => dispatch(deleteProcessLabel({ processId: processDetail._id, labelId }))}>
                      <i
                        className='fa fa-times'
                        aria-hidden='true'
                        style={{ color: luminance > 0.4 ? '#333333' : '#ffffff' }}
                      ></i>
                    </button>
                  </div>
                )
              }

              return null
            })
          }
        </div>
      )}
    </div>

    {/* Contenedor "Al entrar en el proceso" */}
    {processDetail.onNewProcess && isAdvanceModeEnabled && (
      <div className='process-content__actions-container-wrapper'>
        <ProcessContainer
          data={processDetail.onNewProcess}
          toggleActionModal={toggleActionModal}
          toggleDeleteActionModal={toggleDeleteActionModal}
          isOpenCopyContainerModal={isOpenCopyContainerModal}
          toggleCopyContainerModal={toggleCopyContainerModal}
          containerCollapse={smartChatCollapse.onNewProcess}
          onChangeSmartChatCollapse={onChangeSmartChatCollapse}
        />
      </div>
    )}

    {/* Contenedores "En el proceso" */}
    {processDetail.onProcess && (
      <div className='process-content__actions-container-wrapper'>
        {processDetail.onProcess.map((onProcess, index) => (
          <ProcessContainer
            key={index}
            data={onProcess}
            toggleActionModal={toggleActionModal}
            toggleDeleteActionModal={toggleDeleteActionModal}
            isOpenCopyContainerModal={isOpenCopyContainerModal}
            toggleCopyContainerModal={toggleCopyContainerModal}
            isOpenDeleteContainerModal={isOpenDeleteContainerModal}
            toggleDeleteContainerModal={toggleDeleteContainerModal}
            onChangeSmartChatCollapse={onChangeSmartChatCollapse}
            containerCollapse={smartChatCollapse.onProcess.find(it => it.containerId === onProcess.containerId)}
          />
        ))}
        <Button
          container
          value={I18n.t('chatbot_button_addContainer')}
          onClick={toggleAddContainerModal}
        />
      </div>
    )}

    {/* Contenedor "Al salir del proceso" */}
    {processDetail.onLeaveProcess && isAdvanceModeEnabled && (
      <div className='process-content__actions-container-wrapper'>
        <ProcessContainer
          data={processDetail.onLeaveProcess}
          toggleActionModal={toggleActionModal}
          toggleDeleteActionModal={toggleDeleteActionModal}
          isOpenCopyContainerModal={isOpenCopyContainerModal}
          toggleCopyContainerModal={toggleCopyContainerModal}
          containerCollapse={smartChatCollapse.onLeaveProcess}
          onChangeSmartChatCollapse={onChangeSmartChatCollapse}
        />
      </div>
    )}

    {processDetail.message && <p className='error-message'>{I18n.t('smartchat_error_get_process')}</p>}

    {/* Modal para añadir una acción */}
    {isOpenActionModal && <ActionModal isOpen={isOpenActionModal} toggle={toggleActionModal} />}

    {/* Modal para eliminar una acción */}
    <ModalDelete
      isOpen={isOpenDeleteActionModal}
      toggle={toggleDeleteActionModal}
      header={I18n.t('dashboard_delete-action')}
      text1={I18n.t('dashboard_sure-want-delete-action')}
      text2={I18n.t('dashboard_process-cannot-reversed')}
      event={() => dispatch(saveActionDetail({ onFinish: toggleDeleteActionModal }))}
      isSubmitting={modalLoading}
      errorMessage={modalError?.message}
    />

    {/* Modal para añadir contenedor (En el proceso) */}
    <ModalWrapper
      isOpen={isOpenAddContainerModal}
      toggle={toggleAddContainerModal}
      header={I18n.t('dashboard_add-container')}
      legend={I18n.t('chatbot_addContainer_legend')}
      eventBtnTxt={I18n.t('dashboard_add')}
      eventBtn={() => dispatch(addContainer({ containerName, onFinish: toggleAddContainerModal }))}
      cancelBtnTxt={I18n.t('dashboard_cancel')}
      cancelBtn={toggleAddContainerModal}
      isSubmitting={modalLoading}
      error={modalError && I18n.t(modalError.message)}
      contentClassName='smartchat-modal'
      body={
        <div className='modal-content modal-content--spaced'>
          <Text
            isRequired
            label={I18n.t('dashboard_container-name')}
            placeholder={I18n.t('chatbot_container_placeholder_name')}
            value={containerName}
            onChange={setContainerName}
          />
        </div>
      }
    />

    {/* Modal para copiar contenedor a otro proceso */}
    <ModalWrapper
      isOpen={isOpenCopyContainerModal}
      toggle={toggleCopyContainerModal}
      header={I18n.t('chatbot_copyContainer_header')}
      legend={I18n.t('chatbot_copyContainer_legend')}
      eventBtnTxt={I18n.t('dashboard_copy')}
      eventBtn={() => dispatch(copyContainer({
        containerData: selectedContainerData,
        copyToProcess: copyContainerValue?.value || '',
        onCallback: toggleConfirmCopyContainerModal,
        onFinish: toggleCopyContainerModal
      }))}
      cancelBtnTxt={I18n.t('dashboard_cancel')}
      cancelBtn={toggleCopyContainerModal}
      isSubmitting={modalLoading}
      error={modalError && I18n.t(modalError.message)}
      contentClassName='smartchat-modal'
      body={
        <div className='modal-content modal-content--spaced'>
          <Selector
            isRequired
            label={I18n.t('chatbot_container_label_copy')}
            placeholder={I18n.t('dashboard_choose-process')}
            options={copyContainerOptions}
            value={copyContainerValue}
            onChange={setCopyContainerValue}
          />
        </div>
      }
    />

    {/*
      Modal de confirmación para copiar contenedor a otro proceso
      (Al entrar en el proceso y Al salir del proceso)
    */}
    <ModalWrapper
      isOpen={isOpenConfirmCopyContainerModal}
      toggle={toggleConfirmCopyContainerModal}
      eventBtnTxt={I18n.t('dashboard_confirm')}
      eventBtn={() => dispatch(confirmCopyContainer({
        containerData: selectedContainerData,
        copyToProcess: copyContainerValue?.value || '',
        onCallback: toggleConfirmCopyContainerModal,
        onFinish: toggleCopyContainerModal
      }))}
      cancelBtnTxt={I18n.t('dashboard_cancel')}
      cancelBtn={toggleConfirmCopyContainerModal}
      isSubmitting={modalLoading}
      error={modalError && I18n.t(modalError.message)}
      contentClassName='smartchat-modal'
      body={
        <div className='modal-content modal-content--spaced'>
          <p>{I18n.t('chatbot_copyContainer_confirm')}</p>
        </div>
      }
    />

    {/* Modal para eliminar contenedor (En el proceso) */}
    <ModalDelete
      isOpen={isOpenDeleteContainerModal}
      toggle={toggleDeleteContainerModal}
      header={I18n.t('chatbot_delete_container')}
      text1={I18n.t('chatbot_delete_container_title')}
      text2={I18n.t('chatbot_delete_container_legend')}
      event={() => dispatch(deleteContainer({ containerId: selectedContainerData.containerId, onFinish: toggleDeleteContainerModal }))}
      isSubmitting={modalLoading}
      errorMessage={modalError?.message}
    />

    {/* Modal para añadir/editar etiquetas */}
    {labelModal.isOpen && (
      <LabelModal
        isOpen={labelModal.isOpen}
        toggle={toggleLabelModal}
        mode={labelModal.mode}
        labelId={labelModal.labelId}
      />
    )}

    {/* Modal para eliminar etiquetas */}
    <ModalDelete
      isOpen={labelModal.isOpenDelete}
      toggle={toggleDeleteLabelModal}
      header={I18n.t('dashboard_delete-label')}
      text1={I18n.t('dashboard_sure-want-remove-label')}
      text2={I18n.t('dashboard_action-cannot-reversed')}
      event={() => dispatch(deleteLabel({ labelId: labelModal.labelId, onFinish: toggleDeleteLabelModal }))}
      isSubmitting={modalHeaderLoading}
      errorMessage={modalHeaderError?.message}
    />
  </div>
)

export default ProcessContentUI
